import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";

@Injectable()
export class ShareHoldersService {
  baseUrl: string = environment.api_base_url;

  constructor(private http: HttpClient) {}

  getShareHolders() {
    return this.http.get(`${this.baseUrl}share_holders`);
  }

  createShareHolder(payload: any) {
    return this.http.post(`${this.baseUrl}share_holders`, payload);
  }

  updateShareHolder(id: number, payload: any) {
    return this.http.put(`${this.baseUrl}share_holders/${id}`, payload);
  }

  deleteShareHolder(id: number) {
    return this.http.delete(`${this.baseUrl}share_holders/${id}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/share-holders/share-holders.service.ts